var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'game',
    'game-spell',
    (_vm.status !== undefined || _vm.showSolution) && 'game-finished',
  ]},[_c('Keypress',{attrs:{"key-event":"keyup","prevent-default":false},on:{"success":function($event){return _vm.onKeyUp($event)}}}),_c('h2',[_vm._v("Spell")]),(_vm.selectedWord)?_c('div',{attrs:{"title":_vm.selectedWord[_vm.gameTargetLang]}},[_c('div',{class:`word-src word-${_vm.gameSrcLang}`},[_vm._v(" "+_vm._s(_vm.selectedWord[_vm.gameSrcLang])+" ")]),_c('div',{class:`word-target word-${_vm.gameTargetLang}`},_vm._l((_vm.letters),function(letter,index){return _c('div',{key:`spell-${_vm.gameTargetLang}-${index}`,class:[
          letter !== ' ' ? 'letter' : 'blank',
          index === _vm.current && 'current',
          letter !== ' ' &&
            _vm.input[index] !== ' ' &&
            (letter === _vm.input[index] ? 'letter-ok' : 'letter-error'),
        ],attrs:{"title":letter},on:{"click":function($event){return _vm.onClick($event, index)}}},[_vm._v(" "+_vm._s(_vm.showSolution ? letter : _vm.input[index])+" ")])}),0)]):_vm._e(),_c('IcelandicCharacters',{on:{"is-char-event":_vm.onIsChar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }